import { CallAPI } from "../../apiManager/ApiCall";
import {
  anatomyAnnotationsBulkURL,
  anatomyAnnotationsURL,
} from "../../apiManager/APIConfig";

export const ListAnatomyAnnotationsCall = async (slideId) =>
  CallAPI({
    url: `${anatomyAnnotationsURL}?slide_id=${encodeURIComponent(slideId)}`,
    method: "GET",
  });

export const CreateAnatomyAnnotationCall = async (body) =>
  CallAPI({
    url: anatomyAnnotationsURL,
    method: "POST",
    body,
  });

export const UpdateAnatomyAnnotationCall = async (id, body) =>
  CallAPI({
    url: `${anatomyAnnotationsURL}/${encodeURIComponent(id)}`,
    method: "PUT",
    body,
  });

export const DeleteAnatomyAnnotationCall = async (id) =>
  CallAPI({
    url: `${anatomyAnnotationsURL}/${encodeURIComponent(id)}`,
    method: "DELETE",
  });

export const SaveAnatomyAnnotationsBulkCall = async (body) =>
  CallAPI({
    url: anatomyAnnotationsBulkURL,
    method: "POST",
    body,
  });
